"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4066,9262],{

/***/ 23887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ Image2; },
/* harmony export */   "Ei": function() { return /* binding */ Img; }
/* harmony export */ });
/* unused harmony exports shouldShowFallbackImage, useImage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44040);
// ../../../react-shim.js


// src/image.tsx


// ../../utilities/object-utils/src/index.ts
function omit(object, keysToOmit = []) {
  const clone = Object.assign({}, object);
  for (const key of keysToOmit) {
    if (key in clone)
      delete clone[key];
  }
  return clone;
}

// src/use-image.ts


function useImage(props) {
  const {
    loading,
    src,
    srcSet,
    onLoad,
    onError,
    crossOrigin,
    sizes,
    ignoreFallback
  } = props;
  const [status, setStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("pending");
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setStatus(src ? "loading" : "pending");
  }, [src]);
  const imageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  const load = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (!src)
      return;
    flush();
    const img = new Image();
    img.src = src;
    if (crossOrigin)
      img.crossOrigin = crossOrigin;
    if (srcSet)
      img.srcset = srcSet;
    if (sizes)
      img.sizes = sizes;
    if (loading)
      img.loading = loading;
    img.onload = (event) => {
      flush();
      setStatus("loaded");
      onLoad == null ? void 0 : onLoad(event);
    };
    img.onerror = (error) => {
      flush();
      setStatus("failed");
      onError == null ? void 0 : onError(error);
    };
    imageRef.current = img;
  }, [src, crossOrigin, srcSet, sizes, onLoad, onError, loading]);
  const flush = () => {
    if (imageRef.current) {
      imageRef.current.onload = null;
      imageRef.current.onerror = null;
      imageRef.current = null;
    }
  };
  (0,_chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useSafeLayoutEffect */ .G)(() => {
    if (ignoreFallback)
      return void 0;
    if (status === "loading") {
      load();
    }
    return () => {
      flush();
    };
  }, [status, load, ignoreFallback]);
  return ignoreFallback ? "loaded" : status;
}
var shouldShowFallbackImage = (status, fallbackStrategy) => status !== "loaded" && fallbackStrategy === "beforeLoadOrError" || status === "failed" && fallbackStrategy === "onError";

// src/native-image.tsx

var NativeImage = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function NativeImage2(props, ref) {
  const { htmlWidth, htmlHeight, alt, ...rest } = props;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width: htmlWidth,
    height: htmlHeight,
    ref,
    alt,
    ...rest
  });
});
NativeImage.displayName = "NativeImage";

// src/image.tsx
var Image2 = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function Image3(props, ref) {
  const {
    fallbackSrc,
    fallback,
    src,
    srcSet,
    align,
    fit,
    loading,
    ignoreFallback,
    crossOrigin,
    fallbackStrategy = "beforeLoadOrError",
    referrerPolicy,
    ...rest
  } = props;
  const providedFallback = fallbackSrc !== void 0 || fallback !== void 0;
  const shouldIgnoreFallbackImage = loading != null || ignoreFallback || !providedFallback;
  const status = useImage({
    ...props,
    ignoreFallback: shouldIgnoreFallbackImage
  });
  const showFallbackImage = shouldShowFallbackImage(status, fallbackStrategy);
  const shared = {
    ref,
    objectFit: fit,
    objectPosition: align,
    ...shouldIgnoreFallbackImage ? rest : omit(rest, ["onError", "onLoad"])
  };
  if (showFallbackImage) {
    if (fallback)
      return fallback;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.img */ .m$.img, {
      as: NativeImage,
      className: "chakra-image__placeholder",
      src: fallbackSrc,
      ...shared
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.img */ .m$.img, {
    as: NativeImage,
    src,
    srcSet,
    crossOrigin,
    loading,
    referrerPolicy,
    className: "chakra-image",
    ...shared
  });
});
Image2.displayName = "Image";

// src/img.tsx

var Img = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.img */ .m$.img, {
  ref,
  as: NativeImage,
  className: "chakra-image",
  ...props
}));



/***/ }),

/***/ 51469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports Hide, Show, useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18229);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54302);
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints */ .AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";



/***/ }),

/***/ 29262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_OfferPreviewCard; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/index.esm.js
var image_dist_index_esm = __webpack_require__(23887);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/OfferPreviewCard/Desktop.tsx






var OfferPreviewCardDesktop = function OfferPreviewCardDesktop(_ref) {
  var _offerData$vehicle, _offerData$vehicle$im;

  var offerData = _ref.offerData;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* SimpleGrid */.MI, {
    bg: "transparent",
    mt: "0",
    width: "100%",
    templateColumns: "35fr 65fr",
    position: "relative",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
        borderRadius: "10px",
        width: {
          md: 40
        },
        src: (_offerData$vehicle = offerData.vehicle) === null || _offerData$vehicle === void 0 ? void 0 : (_offerData$vehicle$im = _offerData$vehicle.image) === null || _offerData$vehicle$im === void 0 ? void 0 : _offerData$vehicle$im.path,
        alt: offerData.vehicle.name
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
      mt: {
        base: 4,
        md: 0
      },
      ml: {
        md: 4
      },
      textAlign: "left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1rem",
        color: "baseDark",
        display: "inline-block",
        mr: "s",
        children: offerData.vehicle.name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        fontFamily: "Montserrat-Regular",
        color: "baseNeutral.700",
        fontSize: "0.875rem",
        display: "inline-block",
        children: offerData.vehicle.version
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        mt: "s",
        textAlign: "left",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          color: "baseDark",
          fontFamily: "Montserrat-Regular",
          fontSize: "0.875rem",
          display: "inline-block",
          children: t('nltCustomizeOfferModalStepsComponent:duration')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
          ml: "s",
          color: "baseDark",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "0.875rem",
          display: "inline-block",
          children: [offerData.contractLength, " ", t('nltCustomizeOfferModalStepsComponent:months')]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        textAlign: "left",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          color: "baseDark",
          fontFamily: "Montserrat-Regular",
          fontSize: "0.875rem",
          display: "inline-block",
          children: t('nltCustomizeOfferModalStepsComponent:kmPerYear')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          ml: "s",
          color: "baseDark",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "0.875rem",
          display: "inline-block",
          children: offerData.annualMileage == 0 ? 'illimitati' : offerData.annualMileage.toLocaleString('it-IT')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        textAlign: "left",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          color: "baseDark",
          fontFamily: "Montserrat-Regular",
          fontSize: "0.875rem",
          display: "inline-block",
          children: t('nltCustomizeOfferModalStepsComponent:deposit')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
          ml: "s",
          color: "baseDark",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "0.875rem",
          display: "inline-block",
          children: [offerData.deposit.toLocaleString('it-IT'), "\u20AC"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        position: "absolute",
        right: "0",
        bottom: "1",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
          fontFamily: "Montserrat-SemiBold",
          fontSize: "1.5rem",
          color: "baseDark",
          align: "right",
          children: ["\u20AC ", offerData.monthlyRate.toLocaleString('it-IT')]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          fontFamily: "Montserrat-Medium",
          color: "baseNeutral.700",
          fontSize: "0.625rem",
          align: "right",
          children: t('nltCustomizeOfferModalStepsComponent:monthlyTaxExluded')
        })]
      })]
    })]
  });
};

/* harmony default export */ var Desktop = (OfferPreviewCardDesktop);
;// CONCATENATED MODULE: ./src/components/OfferPreviewCard/Mobile.tsx







var OfferPreviewCardMobile = function OfferPreviewCardMobile(_ref) {
  var _offerData$vehicle, _offerData$vehicle$im;

  var offerData = _ref.offerData;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* SimpleGrid */.MI, {
      bg: "transparent",
      mt: "0",
      width: "100%",
      templateColumns: "35fr 65fr",
      position: "relative",
      spacingX: "m",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
        flexShrink: 0,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
          borderRadius: "10px",
          src: (_offerData$vehicle = offerData.vehicle) === null || _offerData$vehicle === void 0 ? void 0 : (_offerData$vehicle$im = _offerData$vehicle.image) === null || _offerData$vehicle$im === void 0 ? void 0 : _offerData$vehicle$im.path,
          alt: offerData.vehicle.name
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        mt: {
          base: 4,
          md: 0
        },
        ml: "1px",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          fontFamily: "Montserrat-SemiBold",
          fontSize: "1rem",
          color: "baseDark",
          children: offerData.vehicle.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          fontFamily: "Montserrat-Regular",
          color: "baseNeutral.700",
          fontSize: "0.875rem",
          children: offerData.vehicle.version
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
      mt: "s",
      textAlign: "left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        color: "baseDark",
        fontFamily: "Montserrat-Regular",
        fontSize: "0.875rem",
        display: "inline-block",
        children: t('nltCustomizeOfferModalStepsComponent:duration')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
        ml: "s",
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "0.875rem",
        display: "inline-block",
        children: [offerData.contractLength, " ", t('nltCustomizeOfferModalStepsComponent:months')]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
      textAlign: "left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        color: "baseDark",
        fontFamily: "Montserrat-Regular",
        fontSize: "0.875rem",
        display: "inline-block",
        children: t('nltCustomizeOfferModalStepsComponent:kmPerYear')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        ml: "s",
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "0.875rem",
        display: "inline-block",
        children: offerData.annualMileage == 0 ? 'illimitati' : offerData.annualMileage.toLocaleString('it-IT')
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
      textAlign: "left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        color: "baseDark",
        fontFamily: "Montserrat-Regular",
        fontSize: "0.875rem",
        display: "inline-block",
        children: t('nltCustomizeOfferModalStepsComponent:deposit')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
        ml: "s",
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "0.875rem",
        display: "inline-block",
        children: [offerData.deposit.toLocaleString('it-IT'), "\u20AC"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
      position: "absolute",
      right: "5",
      bottom: "7",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1.5rem",
        color: "baseDark",
        align: "right",
        children: ["\u20AC ", offerData.monthlyRate.toLocaleString('it-IT')]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        fontFamily: "Montserrat-Medium",
        color: "baseNeutral.700",
        fontSize: "0.625rem",
        align: "right",
        children: t('nltCustomizeOfferModalStepsComponent:monthlyTaxExluded')
      })]
    })]
  });
};

/* harmony default export */ var Mobile = (OfferPreviewCardMobile);
;// CONCATENATED MODULE: ./src/components/OfferPreviewCard/index.tsx






var OfferPreviewCard = function OfferPreviewCard(_ref) {
  var offerData = _ref.offerData;
  var isMobile = (0,index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });
  return isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(Mobile, {
    offerData: offerData
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Desktop, {
    offerData: offerData
  });
};

/* harmony default export */ var components_OfferPreviewCard = (OfferPreviewCard);

/***/ }),

/***/ 94066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_ResumeOfferModalContainer; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(70461);
// EXTERNAL MODULE: ./src/uikit/index.tsx + 33 modules
var uikit = __webpack_require__(58598);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var media_query_dist_index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 1 modules
var modal_dist_index_esm = __webpack_require__(83292);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./src/components/OfferPreviewCard/index.tsx + 2 modules
var OfferPreviewCard = __webpack_require__(29262);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ResumeOfferModal/OfferPreviewCardContainer.tsx








var OfferPreviewCardContainer = function OfferPreviewCardContainer(_ref) {
  var offerData = _ref.offerData;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobile = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
    bg: "baseWhite",
    borderRadius: "10px",
    p: "l",
    width: isMobile ? '100%' : '66%',
    mx: "auto",
    mt: "xl",
    boxShadow: "md",
    position: "relative",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* LimitedOfferBadge */.Ld, {
      marginTop: "-35px",
      marginBottom: "10px",
      textAlign: "center",
      children: t('resumeOfferModalContainer:expiringOfferBadge')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OfferPreviewCard["default"], {
      offerData: offerData
    })]
  });
};

/* harmony default export */ var ResumeOfferModal_OfferPreviewCardContainer = (OfferPreviewCardContainer);
;// CONCATENATED MODULE: ./src/components/ResumeOfferModal/index.tsx








var ResumeOfferModal = function ResumeOfferModal(_ref) {
  var customizedOffer = _ref.customizedOffer,
      title = _ref.title,
      subTitle = _ref.subTitle,
      description = _ref.description,
      descsecureDataTextription = _ref.descsecureDataTextription,
      closeText = _ref.closeText,
      closeTextMobile = _ref.closeTextMobile,
      submitText = _ref.submitText,
      submitAction = _ref.submitAction,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose;

  if (!customizedOffer) {
    return null;
  }

  var isMobile = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
    onClose: onClose,
    isOpen: isOpen,
    size: "xl",
    isCentered: true,
    closeOnOverlayClick: false,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
      backgroundColor: "baseNeutral.100",
      minWidth: isMobile ? null : '890px',
      borderRadius: "10px",
      px: isMobile ? 'xl' : 'xxl',
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
        borderBottom: "1px solid #dadde1",
        fontFamily: "Montserrat-SemiBold",
        px: "0",
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {
        mt: "1"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalBody */.fe, {
        m: "0",
        px: "0",
        pb: "xl",
        pt: "l",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
          fontFamily: "Montserrat-SemiBold",
          fontSize: {
            base: '1rem',
            md: '1.125rem'
          },
          color: "baseDark",
          mb: "l",
          children: subTitle
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
          fontFamily: "Montserrat-Regular",
          fontSize: {
            base: '0.875rem',
            md: '1rem'
          },
          color: "baseDark",
          children: description
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ResumeOfferModal_OfferPreviewCardContainer, {
          offerData: customizedOffer
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
          fontFamily: "Montserrat-Medium",
          fontSize: "0.625rem",
          color: "baseDark",
          textAlign: "center",
          mt: "s",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* LockIcon */.mB, {}), " ", descsecureDataTextription]
        }), !isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
          width: "66%",
          mx: "auto",
          mt: "xl",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
              variant: "ghost",
              fontFamily: "Montserrat-Medium",
              color: "primaryGreen.800",
              fontSize: "1rem",
              textTransform: "uppercase",
              fontWeight: "normal",
              onClick: onClose,
              children: closeText
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Spacer */.LZ, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* SecondaryButton */.kq, {
              title: submitText,
              action: submitText.toUpperCase(),
              fontSize: "1rem",
              onClick: submitAction
            })
          })]
        })]
      }), isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalFooter */.mz, {
        px: "0",
        mx: "0",
        justifyContent: "space-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
          variant: "ghost",
          fontFamily: "Montserrat-Medium",
          color: "primaryGreen.800",
          fontSize: "1rem",
          textTransform: "uppercase",
          fontWeight: "normal",
          onClick: onClose,
          children: closeTextMobile
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* SecondaryButton */.kq, {
          title: submitText,
          action: submitText.toUpperCase(),
          fontSize: "1rem",
          onClick: submitAction,
          width: "inherit"
        })]
      })]
    })]
  });
};

/* harmony default export */ var components_ResumeOfferModal = (ResumeOfferModal);
// EXTERNAL MODULE: ./src/redux/nlt-offer/actions.ts
var actions = __webpack_require__(57543);
;// CONCATENATED MODULE: ./src/containers/ResumeOfferModalContainer.tsx











var ResumeOfferModalContainer = function ResumeOfferModalContainer() {
  var dispatch = (0,es/* useDispatch */.I0)();
  var router = (0,next_router.useRouter)();

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var _useDisclosure = (0,index_esm/* useDisclosure */.qY)(),
      isOpen = _useDisclosure.isOpen,
      onOpen = _useDisclosure.onOpen,
      onClose = _useDisclosure.onClose;

  var _useCookies = (0,useCookies/* default */.Z)(),
      _useCookies2 = (0,slicedToArray/* default */.Z)(_useCookies, 2),
      cookies = _useCookies2[0],
      setCookie = _useCookies2[1];

  var user = (0,es/* useSelector */.v9)(function (state) {
    var _state$user;

    return (_state$user = state.user) === null || _state$user === void 0 ? void 0 : _state$user.profile;
  });
  var customizedOffer = (0,es/* useSelector */.v9)(function (state) {
    var _state$user2, _state$user2$profile;

    return (_state$user2 = state.user) === null || _state$user2 === void 0 ? void 0 : (_state$user2$profile = _state$user2.profile) === null || _state$user2$profile === void 0 ? void 0 : _state$user2$profile.deal;
  });
  var customizeModalIsOpen = (0,es/* useSelector */.v9)(function (state) {
    return state.nlt.customizeModalIsOpen;
  });

  var closeHanlder = function closeHanlder() {
    setCookie('resumeOfferModalHidden', true, {
      path: '/'
    });
    onClose();
  };

  (0,react.useEffect)(function () {
    if (customizedOffer && !cookies.resumeOfferModalHidden) {
      onOpen();
    }
  });

  if (!user || !customizedOffer || !customizedOffer.deal || customizeModalIsOpen) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_ResumeOfferModal, {
    customizedOffer: customizedOffer,
    title: t('resumeOfferModalContainer:title', {
      username: user.firstName
    }),
    subTitle: t('resumeOfferModalContainer:subTitle', {
      car: customizedOffer.vehicle.name
    }),
    description: t('resumeOfferModalContainer:description'),
    descsecureDataTextription: t('resumeOfferModalContainer:secureDataText'),
    closeText: t('resumeOfferModalContainer:closeText'),
    closeTextMobile: t('resumeOfferModalContainer:closeTextMobile'),
    submitText: t('resumeOfferModalContainer:submitText'),
    submitAction: function submitAction() {
      if (customizedOffer.qualification.isQualified) {
        router.push("/caricamento-documenti");
      } else {
        router.push("/noleggio-a-lungo-termine/".concat(customizedOffer.offerCode)).then(function () {
          closeHanlder();
          dispatch((0,actions/* toggleCustomizeModal */.K2)({
            step: 3
          }));
        });
      }
    },
    isOpen: isOpen,
    onClose: closeHanlder
  });
};

/* harmony default export */ var containers_ResumeOfferModalContainer = (ResumeOfferModalContainer);

/***/ })

}]);